<template>
  <v-container bg="b">
    <p class="about-slogan text-sm">
      {{ dic.brand }} - {{ dic.aboutSection.subTitle }}
    </p>
  </v-container>
</template>

<script>
import VContainer from '@/components/ui/VContainer'

export default {
  name: 'About',
  components: { VContainer },
  computed: {
    currentLang() {
      //this need for wake up store listner
      return this.$store.state.main.currentLang
    },
    dic() {
      this.currentLang //this need for wake up store listner
      return this.$store.state.main.dic
    },
  },
}
</script>

<style lang="scss" scoped>
@media (max-width: 375px) {
}

@media (max-width: 411px) {
}

@media (max-width: 768px) {
  .imac {
    display: none;
  }
}
</style>

<style scoped lang="scss">
.about-slogan {
  color: #e4e8ec;
  max-width: 580px;
  margin: 0 auto;
  line-height: 1.5;
  font-weight: 200;
  text-align: center;
  padding: 20px 0;
}
</style>
